import React from 'react';
//material
import {Card, CardContent, withStyles, Divider, Button} from '@material-ui/core';
import {Skeleton} from '@material-ui/lab';
//styles
import styles from './competition-card-styles';
//utils
import {TeamPlayStatus} from '../../../utils/constants';

const CompetitionCardView = (props) => {
  const {classes, isLoading, competition, handleSetViewEnterResults} = props;

  return (
    <Card>
      <CardContent className={classes.cardContent}>
        {
          isLoading ?
            <Skeleton height={40} width={'60%'} /> :
            <div className={classes.eventName}>
              { competition.competitionName }
            </div>
        }

        {
          !isLoading && competition.teamPlayStatus.id === TeamPlayStatus.Playing && competition.canScore &&
          <Button
            color={'primary'}
            size={'small'}
            aria-label={'small'}
            variant={'contained'}
            className={classes.resultsButton}
            onClick={() => handleSetViewEnterResults(true)}>
            Enter Results
          </Button>
        }

        {
          isLoading ?
            <Skeleton height={22} width={'40%'} /> :
            <div className={classes.subheader}>
              {competition.pairName}
            </div>
        }

        {
          isLoading ?
            <Skeleton height={22} width={'40%'} /> :
            <div className={classes.subheader}>
              {competition.clubName}
            </div>
        }

        <Divider className={classes.divider} />

        {
          isLoading ?
            <Skeleton height={52} width={'40%'} className={classes.description} /> :
            <div className={classes.description}>
              {competition.description}
            </div>
        }
      </CardContent>
    </Card>
  );
};

export default withStyles(styles) (CompetitionCardView);
